import Vue from 'vue'
import Vuex from 'vuex'

import biomedica from './biomedica/biomedica.js'
import calidad from './calidad/calidad.js'
import cirugia from './cirugia/cirugia.js'
import catalogos from './catalogos/catalogos.js'
import cocina from './cocina/cocina.js'
import comunes from './comunes.js'
import consulta from './consulta/consulta.js'
import enfermeria from './enfermeria/enfermeria.js'
import http from './http/calls.js'
import imagen from './imagen/imagen.js'
import laboratorio from './laboratorio/laboratorio.js'
import mtto from './mtto/mtto.js'
import notas from './notas/notas.js'
import pacientes from './pacientes/pacientes.js'
import rhumanos from './rhumanos/rhumanos.js'
import security from './security.js'
Vue.use(Vuex)

export default new Vuex.Store({
    modules:{
        biomedica,
        calidad,
        catalogos,
        cirugia,
        cocina,
        comunes,
        consulta,
        enfermeria,
        http,
        imagen,
        laboratorio,
        mtto,
        notas,
        pacientes,
        rhumanos,
        security,
    }
})
